import { InstitutionAccountLink } from "@bitwarden/web-vault/app/models/types/institution.type";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";

/** Points the account at an institution and product by hand (account details, Edit Account), outside
 * institution details' link flow. rootInstitutionLink records the manual institution whose link moved the
 * account away, so linking it again or unlinking it moves the account too. Moving the account to
 * another institution ends that, so it's cleared; changing only the product keeps it. */
export const setAccountInstitutionLink = (
  account: AccountView,
  link: InstitutionAccountLink,
): void => {
  if (account.institutionLink?.institutionId !== link.institutionId) {
    account.rootInstitutionLink = null;
  }
  account.institutionLink = link;
};
